import MemberSenioritiesForm from './MemberSenioritiesForm.component';

export default MemberSenioritiesForm;
